import { AfterContentInit, Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../data-services/auth.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SidePanelComponent } from '../../../side-panel/feature/side-panel.component';
import { Title } from '@angular/platform-browser';
import { tap } from 'rxjs';

@Component({
  selector: 'app-boilerplate',
  imports: [RouterModule,SidePanelComponent],
  templateUrl: '../ui/boilerplate.component.html',
  styleUrl: '../ui/boilerplate.component.css'
})
export class BoilerplateComponent implements OnInit {
  private readonly _authService = inject(AuthService);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _titleService = inject(Title);

  isLoggedIn: boolean = this._authService.hasValidToken();
  displaySidepanel: boolean = true

  ngOnInit(): void {
    this._titleService.setTitle('LRPTickets.co.uk')
    this._activatedRoute.data.subscribe(routeData => {
      console.log(this._activatedRoute.snapshot.pathFromRoot,routeData)
      this.displaySidepanel = routeData['sidebar'] ?? true
    })
  }
}
